import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../assets/img/record_title.png'
import _imports_1 from '../assets/img/get_code_btn.png'
import _imports_2 from '../assets/img/view_code_btn.png'


const _hoisted_1 = { class: "page-record" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "record-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_3 = { class: "record-inner" }
const _hoisted_4 = {
  key: 0,
  class: "record-list"
}
const _hoisted_5 = { class: "record-item" }
const _hoisted_6 = { class: "time" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "奖品名称：", -1)
const _hoisted_9 = { class: "intro" }
const _hoisted_10 = { class: "code" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "text" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "使用说明：", -1)
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 1,
  class: "record-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.list.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, " 获奖时间：" + _toDisplayString(_ctx.filterTime(item.luckTime)), 1),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (item.state == 1)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "get-code",
                        onClick: ($event: any) => (_ctx.order(item.pid, index)),
                        src: _imports_1,
                        alt: ""
                      }, null, 8, _hoisted_11))
                    : (_openBlock(), _createElementBlock("p", _hoisted_12, [
                        _createTextVNode("您的中奖券码将在48小时内发送至您的手机号，请在手机短信内查看详情。"),
                        (item.code)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                              _createTextVNode("若48小时内未收到兑换码，请重新点击"),
                              _createElementVNode("img", {
                                onClick: ($event: any) => (_ctx.viewCode(item.pid, index)),
                                src: _imports_2,
                                alt: ""
                              }, null, 8, _hoisted_14),
                              _createTextVNode("按钮重新获取。")
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", {
                    class: "intro",
                    innerHTML: item.intro
                  }, null, 8, _hoisted_17)
                ])
              ]))
            }), 256))
          ]))
        : (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("p", _hoisted_18, "暂无中奖记录"))
          : _createCommentVNode("", true)
    ])
  ]))
}